import { getRequestProfilePathname } from '../../../utils/link'
import { EntityArchivedIcon } from '../../Entity'
import {
  PhasesListCell,
  TableBuildingGroupsListCell,
  TableDateCell,
  TableDueDateCell,
  TableDurationCell,
  TableEmptyCell,
  TableFlatCell,
  TableProviderListCell,
  TableRequestNoCell,
  TableStatusCell,
  TableTextCell,
  TableTitleCell,
  TableUserCell,
  TableUserListCell,
  TableVisibilityCell,
  toPhasesCellValue,
  toTableBuildingGroupsListCell,
} from '../../Table'
import { toUserMultiValue } from '../../User'
import { RequestCriticalReasonTag } from '../RequestCriticalReasonTag'

import { RequestTableCellName } from './RequestTableRow.constants'

import * as styles from './RequestTableRow.module.css'

import Archive2Icon from '../../../icons/archive-2.svg'

function getVisibleToDwellerPayloadData(isVisible) {
  return { visible_to_dwellers: !isVisible }
}

function getVisibleToDwellerButtonTooltipTextKey(isVisible) {
  return isVisible
    ? 'RequestTable.MarkAsPrivateKey'
    : 'RequestTable.MarkAsPublicKey'
}

export function renderCell({
  availableSections,
  context,
  extra,
  isArchived,
  isLoading,
  isShort,
  item,
  name,
  showCriticalReason,
  statuses,
  onChangeVisibility,
  onClickDocFlowTag,
  onClickEmailTag,
  onClickFileTag,
  onClickRequestTag,
  ...restProps
}) {
  const { id, [name]: value, unread } = item

  const cellProps = { ...restProps, unread }

  switch (name) {
    case RequestTableCellName.RequestNo:
      return (
        <TableRequestNoCell
          {...cellProps}
          id={id}
          linkTo={
            availableSections
              ? getRequestProfilePathname({ availableSections, id })
              : undefined
          }
          value={value}
        />
      )

    case RequestTableCellName.Title:
      return (
        <TableTitleCell
          {...cellProps}
          AdditionalIcon={showCriticalReason ? RequestCriticalReasonTag : null}
          TextArchivedIcon={isArchived ? EntityArchivedIcon : null}
          additionalIconProps={{ reason: item.critical_reason }}
          avatarProps={{ src: item.avatar }}
          context={context}
          extra={extra}
          id={id}
          isShort={isShort}
          labels={item.labels}
          tagsProps={{
            directoryId: item.directory_id,
          }}
          textArchivedIconProps={{
            Icon: Archive2Icon,
            containerClassName: styles.archivedIconContainer,
          }}
          value={value}
          onClickDocFlowTag={onClickDocFlowTag}
          onClickEmailTag={onClickEmailTag}
          onClickFileTag={onClickFileTag}
          onClickRequestTag={onClickRequestTag}
        />
      )

    case RequestTableCellName.Status:
      return (
        <TableStatusCell {...cellProps} statuses={statuses} value={value} />
      )

    case RequestTableCellName.Category:
      return <TableTextCell {...cellProps} value={value?.name} />

    case RequestTableCellName.Building:
      return <TableTextCell {...cellProps} value={value?.title} />

    case RequestTableCellName.BuildingGroups:
      return (
        <TableBuildingGroupsListCell
          {...cellProps}
          value={value?.map(toTableBuildingGroupsListCell)}
        />
      )

    case RequestTableCellName.Flat:
      return <TableFlatCell {...cellProps} value={value} />

    case RequestTableCellName.BuildingObjectNumber:
      return (
        <TableTextCell {...cellProps} value={item.building?.object_number} />
      )

    case RequestTableCellName.FlatEntranceAddress:
      return (
        <TableTextCell {...cellProps} value={item.flat?.entrance_address} />
      )

    case RequestTableCellName.CompletionTime:
      return <TableDurationCell {...cellProps} value={value} />

    case RequestTableCellName.Assignees:
    case RequestTableCellName.Workers:
      return (
        <TableUserListCell
          {...cellProps}
          value={value?.map(toUserMultiValue)}
        />
      )

    case RequestTableCellName.Contractors:
      return (
        <TableProviderListCell
          {...cellProps}
          value={value?.map(toUserMultiValue)}
        />
      )

    case RequestTableCellName.ClosedBy:
    case RequestTableCellName.CreatedBy:
    case RequestTableCellName.Owner:
    case RequestTableCellName.UpdatedBy:
      return (
        <TableUserCell
          {...cellProps}
          value={value ? toUserMultiValue(value) : null}
        />
      )

    case RequestTableCellName.DueDate:
      return (
        <TableDueDateCell {...cellProps} status={item.status} value={value} />
      )

    case RequestTableCellName.ClosedAt:
    case RequestTableCellName.Created:
    case RequestTableCellName.PrivateUpdated:
    case RequestTableCellName.Updated:
      return <TableDateCell {...cellProps} value={value} />

    case RequestTableCellName.Phases:
      return (
        <PhasesListCell
          {...cellProps}
          id={id}
          value={toPhasesCellValue(value)}
        />
      )

    case RequestTableCellName.VisibleToDwellers:
      return (
        <TableVisibilityCell
          {...cellProps}
          getButtonTooltip={getVisibleToDwellerButtonTooltipTextKey}
          getPayloadData={getVisibleToDwellerPayloadData}
          isLoading={isLoading}
          isVisible={item.visible_to_dwellers}
          onChange={onChangeVisibility}
        />
      )

    case RequestTableCellName.ThreadEmailsCount:
      return <TableTextCell {...cellProps} value={value} />

    default:
      return <TableEmptyCell {...cellProps} unread={unread} />
  }
}
